<template>
    <kt-panel>
        <div class="fh-datatable" >
            <table class="table table-striped">
                <thead>
                <tr style="font-size: 0.89rem;">
                    <td style="text-align: center; width:70px">#</td>
                    <td style="text-align: center">{{ $t('reports.tax.created_at') }}</td>
                    <td style="text-align: center">{{ $t('reports.tax.from_date') }}</td>
                    <td style="text-align: center">{{ $t('reports.tax.to_date') }}</td>
                    <td style="text-align: center">{{ $t('reports.tax.download') }}</td>
                </tr>
                </thead>
                <tbody  v-if="taxExports != null && status === 'success'">
                <tr v-bind:key="index" v-for="(taxExport, index) in taxExports">
                    <td style="text-align: center">{{ taxExport.id }}</td>
                    <td style="text-align: center">{{ taxExport.created_at }}</td>
                    <td style="text-align: center">{{ taxExport.from_date }}</td>
                    <td style="text-align: center">{{ taxExport.to_date }}</td>
                    <td style="text-align: center">
                        <a :href="taxExport.url" class="button">
                            <i class="fa fa-download"></i>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="loader" style="display:none"></div>
    </kt-panel>
</template>

<script>
import { mapGetters } from 'vuex'
import toastr from "toastr";
import $ from "jquery";

export default {

    computed: {
        ...mapGetters('reports', ['taxExports', 'status']),
    },
    mounted() {
        this.$store.dispatch('reports/fetchTaxExports')
    },
    methods: {
            // deleteFromSuspectedIPs(hashid) {
            //     $('.loader').addClass('disp_block')
            //     blackListService.deleteFromSuspectedIPs(hashid).then(response => {
            //         this.$store.dispatch('blackList/fetchSuspectedIps')
            //         this.toastr.success(response.data.message)
            //         $('.loader').removeClass('disp_block')
            //     })
            // }
        }
    }
</script>